<template>
  <section id="releases" class="rt-section releases">
    <div class="rt-inner">
      <div class="releases__head">
        <div>
          <h2 class="rt-section-title releases__title">リリース <span class="releases__sub">Release Notes</span></h2>
          <p class="releases__lead">公開されたシステム更新情報をまとめています。</p>
        </div>
        <router-link to="/releases" class="releases__link">
          すべて見る <i class="fas fa-chevron-right" aria-hidden="true"></i>
        </router-link>
      </div>

      <div v-if="releaseList.length > 0" class="releases__list">
        <article
          v-for="release in releaseList"
          :key="release.id"
          class="releases__row"
        >
          <div class="releases__meta">
            <time class="releases__date">{{ formatReleaseDate(release.productionReleaseDate) }}</time>
            <span class="releases__system">{{ releaseSystemLabel(release.system) }}</span>
          </div>
          <div class="releases__content">
            <div class="releases__version">{{ release.version || '-' }}</div>
            <p v-if="releaseNoteExcerpt(release.releaseNote)" class="releases__excerpt">
              {{ releaseNoteExcerpt(release.releaseNote, 82) }}
            </p>
          </div>
        </article>
      </div>
      <p v-else class="releases__empty">リリース情報はありません</p>
    </div>
  </section>
</template>

<script>
import { defineComponent, onMounted, ref } from 'vue'
import axios from 'axios'
import { releaseListRequest } from '../../lib/monstrsApi'
import { formatReleaseDate, releaseNoteExcerpt, releaseSystemLabel } from '../../lib/releases'

const API_BASE = process.env.VUE_APP_MONSTRS_API

export default defineComponent({
  name: 'HomeReleases',
  setup () {
    const releaseList = ref([])

    onMounted(() => {
      const req = releaseListRequest(API_BASE, 0, 10)
      axios.get(req.url, { params: req.params }).then(response => {
        releaseList.value = (response.data && response.data.list) || []
      }).catch(() => {
        releaseList.value = []
      })
    })

    return {
      releaseList,
      formatReleaseDate,
      releaseNoteExcerpt,
      releaseSystemLabel
    }
  }
})
</script>

<style scoped>
.releases {
  background: var(--surface-soft);
}

.releases__head {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 18px;
  text-align: left;
  margin-bottom: 16px;
}

.releases__title {
  text-align: left;
}

.releases__sub {
  font-family: var(--font-lat);
  font-size: 13px;
  color: var(--ink-mute);
  margin-left: 6px;
}

.releases__lead {
  font-size: 13px;
  line-height: 1.8;
  color: var(--ink-soft);
  margin-top: 6px;
}

.releases__link {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  flex: 0 0 auto;
  color: var(--brand-blue);
  background: #fff;
  border: 1px solid var(--line);
  border-radius: var(--radius-pill);
  padding: 8px 16px;
  font-family: var(--font-head);
  font-size: 13px;
  font-weight: 700;
  text-decoration: none;
  transition: transform 0.15s, background 0.15s;
}

.releases__link:hover {
  background: var(--blue-bg);
  transform: translateY(-1px);
}

.releases__list {
  background: var(--surface);
  border: 1px solid var(--line);
  border-radius: var(--radius);
  overflow: hidden;
}

.releases__row {
  display: grid;
  grid-template-columns: minmax(180px, 230px) 1fr;
  gap: 16px;
  padding: 15px 18px;
  border-bottom: 1px solid var(--line);
  text-align: left;
}

.releases__row:last-child {
  border-bottom: none;
}

.releases__meta {
  display: flex;
  align-items: center;
  gap: 9px;
  min-width: 0;
}

.releases__date {
  font-family: var(--font-lat);
  font-size: 12px;
  color: var(--ink-mute);
  white-space: nowrap;
}

.releases__system {
  display: inline-flex;
  align-items: center;
  min-height: 24px;
  max-width: 100%;
  color: var(--brand-blue);
  background: var(--blue-bg);
  border-radius: var(--radius-pill);
  padding: 3px 10px;
  font-family: var(--font-lat);
  font-size: 11px;
  font-weight: 700;
  white-space: nowrap;
}

.releases__content {
  min-width: 0;
}

.releases__version {
  font-family: var(--font-lat);
  font-size: 13.5px;
  font-weight: 700;
  color: var(--ink);
}

.releases__excerpt {
  margin-top: 2px;
  font-size: 13px;
  line-height: 1.7;
  color: var(--ink-soft);
  overflow-wrap: anywhere;
}

.releases__empty {
  background: var(--surface);
  border: 1px solid var(--line);
  border-radius: var(--radius);
  padding: 28px;
  text-align: center;
  color: var(--ink-mute);
  font-size: 14px;
}

@media (max-width: 768px) {
  .releases__head {
    align-items: flex-start;
    flex-direction: column;
  }

  .releases__row {
    grid-template-columns: 1fr;
    gap: 8px;
    padding: 15px 16px;
  }
}
</style>
